import { lazy } from 'react';

const InvoiceViewer = lazy(() => import('./InvoiceViewer'));

const InvoiceViewerConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/drafts/invoice',
			element: <InvoiceViewer />
		}
	]
};

export default InvoiceViewerConfig;
